import { render, staticRenderFns } from "./BidList.vue?vue&type=template&id=d058366e"
import script from "./BidList.vue?vue&type=script&lang=js"
export * from "./BidList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports